module.exports = __webpack_public_path__ + "img/70747cf.png";